import { Component, OnInit, ViewChild } from '@angular/core';
import { ITdDataTableColumn, TdDataTableSortingOrder, TdDataTableService, ITdDataTableSortChangeEvent, IPageChangeEvent, TdDialogService, TdLoadingService, TdSearchBoxComponent } from '@covalent/core';
import { SettingsService } from '../../../shared/services/settings.service';
import { LocationService } from 'services/location.service';
import { MdDialogRef, MdDialog } from '@angular/material';
import { ExportService } from '../../../shared/services/export.service';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { Utils } from '../../../shared/utils';

@Component({
  selector: 'app-city-country',
  templateUrl: './city-country.component.html',
  styleUrls: ['./city-country.component.scss']
})
export class CityCountryComponent implements OnInit {
  @ViewChild('searchBox') _searchBox: TdSearchBoxComponent;

  data: any[];

  columns: ITdDataTableColumn[] = [
    { name: 'name', label: 'City' },
    { name: 'country_name', label: 'Country' },
  ];

  filteredData: any[];
  filteredTotal: number;
  //searchTerm: string;

  fromRow: number = 1;
  currentPage: number = 1;
  sortBy: string = 'id';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;

  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: MdDialog,
    private _loadingService: TdLoadingService,
    private _locationService: LocationService,
    private _settingsService: SettingsService,
    public _exportService: ExportService,
    public _authService: AuthenticationService
  ) { }

  ngOnInit() {
    this._loadingService.register('loading');

    this.presetSearchBox();

    this._locationService.getCity().subscribe(
      response => {
        console.log(response);
        this.data = response;
      },
      error => {
        console.log(error)
      },
      () => {
        this._loadingService.resolve('loading');
        this.filter();
      }
    );
  }

  presetSearchBox() {
    if (this._settingsService.getSearchTerm('city_country')) {
      this._searchBox.value = this._settingsService.getSearchTerm('city_country');
      this._searchBox.searchClicked();
    }
  }

  openAddNewCityDialog() {
    this._dialogService.open(NewCityDialog).afterClosed().subscribe(
      result => {
        if (result != null) {
          this.data.push(result);
          this.filter();
        }
      }
    );
  }

  deleteSelected() {
    this._loadingService.register('loading');

    this.selectedRows.forEach(
      (city) => {
        this._locationService.removeCity(city.id).subscribe(
          response => {
            if (response['status'] == 'SUCCESS') {
              this.data = this.data.filter(function (c) { return c['id'] != response['id'] });
            } else {
              console.log('Could not delete ' + city.name);
            }
          },
          error => {
            console.log(error);
          },
          () => {
            this._loadingService.resolve('loading');

            this.filter();
          }
        );
      }
    );

    this.selectedRows = [];
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;

    this.sortOrder = sortEvent.order === TdDataTableSortingOrder.Ascending
      ? TdDataTableSortingOrder.Descending
      : TdDataTableSortingOrder.Ascending;

    this.filter();
  }

  search(searchTerm: string): void {
    this._settingsService.setSearchTerm('city_country', searchTerm);
    //this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;

    //this.pageSize = pagingEvent.pageSize;
    this._settingsService.setPageSize(pagingEvent.pageSize);

    this.filter();
  }

  filter(): void {
    let newData: any[] = this.data;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });
    newData = this._dataTableService.filterData(newData, this._settingsService.getSearchTerm('city_country'), true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }
}

@Component({
  selector: 'new-city-dialog',
  template: `
    <div flex layout="column" layout-margin layout-wrap>
      <h4>Enter new city and country</h4>
      <md-divider></md-divider>
      <md-input-container>
        <input mdInput type="text" placeholder="City Name" [(ngModel)]="city">
      </md-input-container>
      <md-select fxFlex="22%" placeholder="Country" [(ngModel)]="country_id">
        <md-option *ngFor="let country of countries" [value]="country.id">{{country.name}}</md-option>
      </md-select>
      <div flex layout="row" layout-wrap>
        <button md-raised-button color="primary" class="bg-blue color-white" (click)="addCity()">Add</button>
        <button md-raised-button color="primary" class="bg-blue color-white" (click)="dialogRef.close()">Close</button>
      </div>
    </div>
  `,
})
export class NewCityDialog implements OnInit {
  countries: any[] = [];

  city: string = '';
  country_id: number = 0;

  constructor(public dialogRef: MdDialogRef<NewCityDialog>,
    private tdDialog: TdDialogService,
    private _locationService: LocationService) { }

  ngOnInit() {
    this._locationService.getCountry().subscribe(
      response => {
        console.log(response);
        this.countries = response;
      },
      error => {
        console.log(error)
      },
      () => { }
    );
  }

  addCity() {
    this._locationService.addCity({ name: this.city, country_id: this.country_id }).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this.tdDialog.openAlert(
            {
              title: 'Success!',
              message: 'City added successfully'
            }
          );
          this.dialogRef.close({ name: this.city, country_id: this.country_id });
        } else {
          this.tdDialog.openAlert(
            {
              title: 'Failed!',
              message: 'Could not add city'
            }
          );
          this.dialogRef.close();
        }
      },
      error => {
        this.tdDialog.openAlert(
          {
            title: 'Error!',
            message: 'An error occurred. Try again later.'
          }
        );
        this.dialogRef.close();
      },
      () => {

      }
    );

  }
}


// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/admin/city-country/city-country.component.ts